import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";
import IconLabelButton from "./IconLabelButton";
import { useInView } from "react-intersection-observer";
import { Box } from "@mui/system";
import PdfViewer from "../components/presentation/common/PdfViewer";

const TermsAndCondition = ({
  documentFile,
  open,
  setOpen,
  handlePolicyAgree,
  fromApplication = false,
  policyDocumentName,
  loading = false,
  title = "Privacy Notice",
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  const handleAgree = () => {
    !loading && handlePolicyAgree();
  };

  // to downlaod pdf
  const onDownloadClick = () => {
    fetch(documentFile).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = policyDocumentName ?? "download";
        alink.click();
      });
    });
  };
  return (
    <>
      <Dialog
        PaperProps={{
          style: {
            minWidth: "900px",
          },
        }}
        open={open}
        disableBackdropClick={true}
        transitionDuration={{ enter: 1000, exit: 700 }}
        disableEscapeKeyDown={true}
        BackdropProps={{ style: { backgroundColor: "rgba(0, 0, 0, 0.8)" } }}
        aria-describedby="alert-dialog-slide-description"
        // style={{ padding: "30px" }}
      >
        <DialogTitle sx={{ textAlign: "start", fontSize: "1.3rem" }}>
          {title}
        </DialogTitle>
        {documentFile && (
          <DialogContent
            sx={{ p: 0, height: "70vh", overflow: "hidden", display: "flex" }}
          >
            <PdfViewer
              hideToolbar={true}
              url={documentFile}
              name={policyDocumentName ?? "document"}
              pdfHeight="70vh"
              afterScrollContent={<Box ref={ref} sx={{ height: 1 }} />}
            />
          </DialogContent>
        )}
        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <IconLabelButton
            variant="text"
            disableRipple={true}
            mylabel={
              fromApplication
                ? "Download terms of business."
                : "Download the privacy notice."
            }
            iconType="download"
            iconPosition="start"
            onClick={onDownloadClick}
          />
          <Box sx={{ display: "flex", gap: 5 }}>
            {fromApplication && (
              <IconLabelButton
                iconPosition="end"
                variant="text"
                mylabel="Cancel"
                onClick={() => setOpen(false)}
                iconType="close"
              />
            )}
            {!inView ? (
              <IconLabelButton
                iconPosition="end"
                variant="contained"
                mylabel="I Agree"
                buttonColor="gray"
              />
            ) : (
              <IconLabelButton
                iconPosition="end"
                variant="contained"
                mylabel="I Agree"
                onClick={handleAgree}
                iconType={loading ? "loading" : "chevron"}
                buttonColor="gradient"
              />
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TermsAndCondition;
